import { render } from "./Forum-archive.vue?vue&type=template&id=271710c6&lang=pug"
import script from "./Forum-archive.vue?vue&type=script&setup=true&lang=js"
export * from "./Forum-archive.vue?vue&type=script&setup=true&lang=js"

import "./Forum-archive.vue?vue&type=style&index=0&id=271710c6&lang=css"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__